import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PremiumWellnessGate({ children }) {
  const { loading, isPremium } = useAuth();
  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-gray-500" data-testid="wellness-gate-loading">Loading…</div>;
  }
  if (!isPremium) return <Navigate to="/#vitality-tests" replace />;
  return children;
}
